import { createReducer } from "@reduxjs/toolkit";
import { TYPES } from "../../common/constants";
import { deDuplicate } from "../processing/deDuplicate";

const fetchServiceRequestsDone = (serviceRequests, { payload }) => {
  let data = payload.map((item) => {
    if (item.area && item.area.name) {
      return { ...item, areaName: item.area.name };
    } else {
      return { ...item, areaName: "" };
    }
  });
  if (serviceRequests.length > 0) {
    return deDuplicate([...serviceRequests, ...data], (k)=>k.id);
  } else {
    return deDuplicate([...data], k=>k.id);
  }
};

const fetchServiceRequestsSearchDone = (_, { payload }) => {
  let data = payload.map((item) => {
    if (item.area && item.area.name) {
      return { ...item, areaName: item.area.name };
    } else {
      return { ...item, areaName: "" };
    }
  });
  return deDuplicate([...data], k=>k.id);
};

const saveServiceRequestDone = (serviceRequests, { payload }) => {
  let data = payload.map((item) => {
    if (item.area && item.area.name) {
      return { ...item, areaName: item.area.name };
    } else {
      return { ...item, areaName: "" };
    }
  });
  return [...data, ...serviceRequests];
};

// export const setRoomName = () => {
//   return payload.map(item => {
//     if(item.area && item.area.name) {
//       return { ...item, areaName: item.area.name}
//     } else {
//       return { ...item, areaName: ''}
//     }
//   })
// }
const updateServiceRequestsStatusDone = (serviceRequests, { payload }) => {
  let d = serviceRequests.map((s) => {
    let object = payload.serviceRequest.filter((p) => p.id === s.id)[0];
    if (object && object.id) {
      return { ...s, status: payload.name };
    } else {
      return s;
    }
  });
  return d;
};
const archiveServiceRequestDone = (serviceRequests, { payload }) => {
  let serviceRequestsList = serviceRequests;
  let data = payload.serviceRequest.map((d) => {
    serviceRequestsList = serviceRequestsList.filter((sr) => sr.id !== d.id);
    return serviceRequestsList;
  })[0];
  return data;
};
const clearServiceRequestsDone = () => {
  return initialState;
};

const initialState = [];

export default createReducer(initialState, {
  [TYPES.SAVE_SERVICE_REQUEST_DONE]: saveServiceRequestDone,
  [TYPES.FETCH_SERVICE_REQUESTS_DONE]: fetchServiceRequestsDone,
  [TYPES.FETCH_SERVICE_REQUESTS_SEARCH_DONE]: fetchServiceRequestsSearchDone,
  [TYPES.UPDATE_SERVICE_REQUEST_STATUS_DONE]: updateServiceRequestsStatusDone,
  [TYPES.ARCHIVE_SERVICE_REQUESTS_DONE]: archiveServiceRequestDone,
  [TYPES.CLEAR_SERVICE_REQUESTS_DONE]: clearServiceRequestsDone,
});
